module.exports = __webpack_public_path__ + "img/background-icons-1.011c7062.png";